/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type SbRespContentModuleSelector_itemSearch = {
    readonly browseContentModule: {
        readonly moduleType: string | null;
        readonly " $fragmentRefs": FragmentRefs<"SbRespContentModuleRegular_browseContentModule" | "SbSharedContentModuleBanner_browseContentModule" | "SbSharedContentModulePromo_browseContentModule" | "SbSharedContentModuleIconicDesign_browseContentModule" | "SbSharedContentModuleBannerTiles_browseContentModule">;
    } | null;
    readonly " $refType": "SbRespContentModuleSelector_itemSearch";
};
export type SbRespContentModuleSelector_itemSearch$data = SbRespContentModuleSelector_itemSearch;
export type SbRespContentModuleSelector_itemSearch$key = {
    readonly " $data"?: SbRespContentModuleSelector_itemSearch$data;
    readonly " $fragmentRefs": FragmentRefs<"SbRespContentModuleSelector_itemSearch">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "contentModuleId"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "SbRespContentModuleSelector_itemSearch",
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "contentModuleId",
          "variableName": "contentModuleId"
        }
      ],
      "concreteType": null,
      "kind": "LinkedField",
      "name": "browseContentModule",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "moduleType",
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "SbRespContentModuleRegular_browseContentModule"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "SbSharedContentModuleBanner_browseContentModule"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "SbSharedContentModulePromo_browseContentModule"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "SbSharedContentModuleIconicDesign_browseContentModule"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "SbSharedContentModuleBannerTiles_browseContentModule"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "ItemSearchQueryConnection",
  "abstractKey": null
};
(node as any).hash = 'ce690f9ed8a09efafc65abebe9a170bc';
export default node;
